import { makeStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useDashboardConfig } from '../../../hooks';
import { WidgetFooterType } from '../widget.types';
const useStyles = makeStyles((theme) => ({
    footer: {
        width: '100%',
        height: 35,
        padding: '0px 10px',
        borderTop: '1px solid #CCCCCC',
        clear: 'both',
        fontSize: theme.font.size.mediumSmall,
        fontWeight: theme.font.weight.bold,
        textTransform: 'uppercase',
        textAlign: 'right',
        lineHeight: '35px',
        '& > a': {
            color: '#276700',
            textDecoration: 'underline',
        },
        '& > i': {
            color: '#276700',
            marginLeft: 5,
        },
    },
}));
const WidgetFooter = ({ widget }) => {
    const { footer } = widget;
    const classes = useStyles();
    const { t } = useTranslation();
    const config = useDashboardConfig();
    const footerConfig = footer instanceof Function ? footer(config) : footer;
    if (footerConfig.type === WidgetFooterType.EMPTY) {
        return null;
    }
    if (footerConfig.type === WidgetFooterType.VIEW_MORE) {
        return (React.createElement("footer", { className: classes.footer },
            React.createElement("a", { href: footerConfig.href, target: "_blank", rel: "noopener noreferrer" }, t(footerConfig.text || 'widget:generic:footer_text'))));
    }
    return null;
};
export default WidgetFooter;
//# sourceMappingURL=WidgetFooter.js.map